import { toast } from 'react-toastify';
import { ToastMessage } from '../kit';
export const toastUtils = {
    success: (data) => {
        const toastProps = {
            icon: false,
            autoClose: 2500,
            closeButton: false
        };
        toast.success(ToastMessage, {
            ...toastProps,
            data: {
                ...data,
                icon: data.icon ?? 'Error'
            }
        });
    },
    error: (data) => {
        const toastProps = {
            icon: false,
            autoClose: 5000,
            closeButton: false
        };
        toast.error(ToastMessage, {
            ...toastProps,
            data: {
                ...data,
                icon: data.icon ?? 'Error'
            }
        });
    }
};
//# sourceMappingURL=toast.utils.js.map